import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Component, Inject} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-confirm-reservation-import',
    template: `
    <div class="row modal-bar">
      <div class="col-sm-6">
        <h5 class="modal-title">{{ data.title }}</h5>
      </div>
      <div class="col-sm-6">
        <div class="modal-actions">
          <div class="modal-close">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
          </div>
        </div>
      </div>
    </div>
    <div class="section-wrapper mt-3">
    <div>
     <p>{{'DIALOGS.CONFIRM-ORDER-IMPORT.SECTION-WRAPPER.YOURE-ABOUT-TO' | translate}} {{ data.payload.processableCount }} {{'DIALOGS.CONFIRM-ORDER-IMPORT.SECTION-WRAPPER.CREATE-ORDERS' | translate}}</p>
      <p class="my-2"><b>{{'DIALOGS.CONFIRM-ORDER-IMPORT.SECTION-WRAPPER.CHOOSE-A-CALM-MOMENT' | translate}}</b></p>
      <p class="mt-3"><label class="fw-normal"><input type="checkbox" [(ngModel)]="groupByCustomer">{{'DIALOGS.CONFIRM-ORDER-IMPORT.SECTION-WRAPPER.GROUP-ORDERS-PER-CUSTOMER' | translate}}</label></p>
      <p class="mt-3"><label class="fw-normal"><input type="checkbox" [(ngModel)]="disableC3V">{{'DIALOGS.CONFIRM-ORDER-IMPORT.SECTION-WRAPPER.DISABLE-C3V' | translate}}</label></p>
    </div>
    </div>
    <div class="form-layout-footer mt-5 row">
      <div class="col-6">
        <button (click)="dialogRef.close({groupByCustomer: groupByCustomer, disableC3V: disableC3V});" class="btn btn-block btn-primary bd-0"><span>{{'GENERIC.BUTTON.OK' | translate}}</span>
        </button>
      </div>
      <div class="col-6">
        <button (click)="dialogRef.close(false);" class="btn btn-block btn-secondary bd-0"><span>{{ 'GENERIC.BUTTON.CANCEL' | translate }}</span>
        </button>
      </div>
    </div>`,
    standalone: false
})
export class ConfirmOrderImportComponent {
  public groupByCustomer = false;
  public disableC3V = false;
  constructor(
    public dialogRef: MatDialogRef<ConfirmOrderImportComponent>,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }
}
